import { createAction, props } from '@ngrx/store';

import { UserCredentials } from '@shared/models';

export namespace LoginPageActions {
  export const initialize = createAction('[Login Page] Initialize');

  export const login = createAction('[Login Page] Login', props<{ userCredentials: UserCredentials }>());

  export const resetLoginError = createAction('[Login Page] Reset Login Error');

  export const passwordExpired = createAction(
    '[Login Page] Password Expired',
    props<{ providerToken: string; email?: string; tenant?: string }>(),
  );

  export const loggedInRedirect = createAction('[Landing Page] Logged In Redirect');

  export const loggedInRedirectToMaintenance = createAction(
    '[Landing Page] Logged In Redirect to Maintenance',
    props<{ tenant?: string }>(),
  );

  export const splashScreenAnimationEnd = createAction('[Landing Page] Splash Screen Animation End');
}
